import { AutomationEventTypes } from "../AutomationModuleTypes";
import AutomationCommon from "../common";

const vt = AutomationCommon.vt;
const contexts = AutomationCommon.contexts;
const ga = AutomationCommon.ga;

class EmailModuleAttributeFactory {
    constructor(parent) {
        this.parent = parent;
    }

    generate() {
        const emailReceivedAttrs = this.emailReceived();
        const sesEventAttrs = this.sesEmailEvents();
        return [...emailReceivedAttrs, ...sesEventAttrs];
    }

    generateEmailAttributes(context, prefix = "") {
        prefix = prefix ? `${prefix}.` : "";

        return [
            ga(context, `${prefix}siteId`, "Site ID"),
            ga(context, `${prefix}messageId`, "Message ID"),
            ga(context, `${prefix}incoming`, "Incoming", vt.BOOLEAN),
            ga(context, `${prefix}sender`, "Sender Email Address"),
            ga(context, `${prefix}senderUserId`, "Sender User Id"),
            ga(context, `${prefix}to_list`, "To Email Address List", vt.ARRAY_STRING),
            ga(context, `${prefix}cc_list`, "CC Email Address List", vt.ARRAY_STRING),
            ga(context, `${prefix}bcc_list`, "BCC Email Address List", vt.ARRAY_STRING),
            ga(context, `${prefix}subject`, "Subject"),
            ga(context, `${prefix}body_text`, "Body Text"),
            ga(context, `${prefix}body_html`, "Body HTML"),
            ga(context, `${prefix}created_at`, "Created Date", vt.DATETIME),
            ga(context, `${prefix}deleted`, "Deleted", vt.BOOLEAN),
            ga(context, `${prefix}replay_to_message_id`, "Replay To Message ID"),
            ga(context, `${prefix}thread_id`, "Thread ID"),
            ga(context, `${prefix}ref_visitor_id`, "Reference Contact", vt.OBJECT, undefined, [
                ...this.parent.generateContactAttributes(`${prefix}ref_visitor_id`),
            ]),
            ga(context, `${prefix}ref_department_ids`, "Reference Department IDS", vt.ARRAY),
            ga(context, `${prefix}is_ticket`, "Is Ticket", vt.BOOLEAN),
            ga(context, `${prefix}attachments`, "Attachments", vt.ARRAY_OBJECT),
        ];
    }

    /**
     * Ortak SES email event payload alanları (type, messageId, mailId, from, to, cc, subject, payload)
     */
    generateSesEventBaseAttributes(prefix) {
        return [
            ga(contexts.EVENT, `${prefix}.$..*`, "*", vt.OBJECT),
            ga(contexts.EVENT, `${prefix}.messageId`, "Message ID", vt.STRING),
            ga(contexts.EVENT, `${prefix}.mailId`, "Mail ID", vt.STRING),
            ga(contexts.EVENT, `${prefix}.from`, "Gönderen (From)", vt.STRING),
            ga(contexts.EVENT, `${prefix}.to`, "Alıcı (To)", vt.ARRAY_STRING),
            ga(contexts.EVENT, `${prefix}.cc`, "CC", vt.ARRAY_STRING),
            ga(contexts.EVENT, `${prefix}.subject`, "Konu (Subject)", vt.STRING),
        ];
    }

    emailReceived() {
        const e = AutomationEventTypes.EMAIL.RECEIVED;
        const context = contexts.EVENT;

        return [
            ga(context, `event.${e}`, "Received Email", vt.OBJECT, undefined, [
                ga(context, `event.${e}.$..*`, "*", vt.OBJECT),
                ...this.generateEmailAttributes(context, `event.${e}.email`),
            ]),
        ];
    }

    sesEmailEvents() {
        const eventConfigs = [
            { e: AutomationEventTypes.EMAIL.DELIVERED, label: "Email Teslim Edildi" },
            { e: AutomationEventTypes.EMAIL.BOUNCED, label: "Email Bounce", subAttrs: [
                ga(contexts.EVENT, `event.${AutomationEventTypes.EMAIL.BOUNCED}.payload.bounce.bounceType`, "Bounce Tipi", vt.STRING),
                ga(contexts.EVENT, `event.${AutomationEventTypes.EMAIL.BOUNCED}.payload.bounce.bounceSubType`, "Bounce Alt Tipi", vt.STRING),
            ]},
            { e: AutomationEventTypes.EMAIL.COMPLAINED, label: "Email Şikayet", subAttrs: [
                ga(contexts.EVENT, `event.${AutomationEventTypes.EMAIL.COMPLAINED}.payload.complaint.complaintFeedbackType`, "Şikayet Tipi", vt.STRING),
            ]},
            { e: AutomationEventTypes.EMAIL.CLICKED, label: "Email Link Tıklandı", subAttrs: [
                ga(contexts.EVENT, `event.${AutomationEventTypes.EMAIL.CLICKED}.payload.link`, "Tıklanan Link", vt.STRING),
            ]},
            { e: AutomationEventTypes.EMAIL.OPENED, label: "Email Açıldı" },
            { e: AutomationEventTypes.EMAIL.SENT, label: "Email Gönderildi" },
            { e: AutomationEventTypes.EMAIL.REJECTED, label: "Email Reddedildi" },
        ];

        return eventConfigs.map(({ e, label, subAttrs }) => {
            const prefix = `event.${e}`;
            const baseAttrs = this.generateSesEventBaseAttributes(prefix);
            const payloadAttr = ga(contexts.EVENT, `${prefix}.payload`, "Payload", vt.OBJECT, undefined, subAttrs || []);
            return ga(contexts.EVENT, prefix, label, vt.OBJECT, undefined, [
                ...baseAttrs,
                subAttrs && subAttrs.length ? payloadAttr : ga(contexts.EVENT, `${prefix}.payload`, "Payload", vt.OBJECT),
            ]);
        });
    }
}

export default EmailModuleAttributeFactory;
